'use strict';

(function () {

  /* ─── Accordion toggle ─── */
  function initAccordions() {
    document.querySelectorAll('[data-prd-accordion]').forEach(function (acc) {
      var header = acc.querySelector('[data-prd-accordion-header]');
      if (!header) return;
      header.addEventListener('click', function () {
        var isOpen = acc.classList.toggle('is-open');
        header.setAttribute('aria-expanded', String(isOpen));
      });
    });
  }

  /* ─── CTA "Added to Bag" confirmation ─── */
  function initCtaConfirmation() {
    var btn = document.querySelector('[data-prd-submit]');
    if (!btn) return;

    function triggerAdded() {
      if (btn.classList.contains('prd-cta--added')) return;
      btn.classList.add('prd-cta--added');
      var span = btn.querySelector('span');
      var orig = span ? span.textContent : '';
      if (span) span.textContent = 'Added to Bag';
      setTimeout(function () {
        btn.classList.remove('prd-cta--added');
        if (span) span.textContent = orig;
      }, 2200);
    }

    /* Only fire on a genuine successful add — Dawn's product-form.js publishes
       cartUpdate on success and cartError on failure (e.g. sold-out variants).
       Previously this watched the button's "loading" class disappearing, which
       happens on BOTH success and failure, so a sold-out add-to-cart attempt
       incorrectly showed "Added to Bag" even though nothing was added. */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, triggerAdded);
    }
  }

  /* ─── Live size display ───
     Removed: this used to read "the first checked radio in the product form"
     as the size, which was correct back when Size was itself the variant
     option. Now Metal/Gemstone occupy that role, so that same radio-change
     event would incorrectly overwrite the size row with e.g. "Gold Vermeil".
     The size row is now updated directly by the picker's own click handler
     in initSizePicker(), and initially defaults to its "Select a size"
     placeholder markup — nothing else should touch it. */

  /* ─── Ring size conversion table ───
     US size (quarter steps, 3–16) -> UK/AU letter, EU size, diameter (mm).
     Diameter is anchored to the exact figures already published in
     size-guide-drawer.liquid (4 through 13, whole/half sizes), with the
     in-between quarter steps and the 3–3¾ / 13¼–16 range extending past
     that guide's table interpolated/extrapolated on the same curve.
     UK and EU are both derived from that diameter at quarter-US resolution
     (not rounded to a whole UK letter / whole EU number, which is coarser
     than the US quarter-size steps and produced duplicate-looking values —
     e.g. two different sizes both showing EU "56"). EU here is the
     circumference in mm to 1 decimal, which is what the EU/French size
     actually measures — just shown at full precision instead of rounded. */
  var RING_SIZE_CONVERSIONS = {
    "3": { uk: "E½", eu: 43.4, mm: 13.8 },
    "3 1/4": { uk: "F½", eu: 44.3, mm: 14.1 },
    "3 1/2": { uk: "G", eu: 44.9, mm: 14.3 },
    "3 3/4": { uk: "G½", eu: 45.9, mm: 14.6 },
    "4": { uk: "H", eu: 46.5, mm: 14.8 },
    "4 1/4": { uk: "I", eu: 47.4, mm: 15.1 },
    "4 1/2": { uk: "I½", eu: 48.1, mm: 15.3 },
    "4 3/4": { uk: "J", eu: 48.7, mm: 15.5 },
    "5": { uk: "J½", eu: 49.3, mm: 15.7 },
    "5 1/4": { uk: "K", eu: 50.0, mm: 15.9 },
    "5 1/2": { uk: "K½", eu: 50.6, mm: 16.1 },
    "5 3/4": { uk: "L", eu: 51.2, mm: 16.3 },
    "6": { uk: "L½", eu: 51.8, mm: 16.5 },
    "6 1/4": { uk: "M", eu: 52.5, mm: 16.7 },
    "6 1/2": { uk: "M½", eu: 53.1, mm: 16.9 },
    "6 3/4": { uk: "N", eu: 53.7, mm: 17.1 },
    "7": { uk: "N½", eu: 54.3, mm: 17.3 },
    "7 1/4": { uk: "O", eu: 55.0, mm: 17.5 },
    "7 1/2": { uk: "O½", eu: 55.6, mm: 17.7 },
    "7 3/4": { uk: "P", eu: 56.2, mm: 17.9 },
    "8": { uk: "P½", eu: 57.2, mm: 18.2 },
    "8 1/4": { uk: "Q", eu: 57.8, mm: 18.4 },
    "8 1/2": { uk: "Q½", eu: 58.4, mm: 18.6 },
    "8 3/4": { uk: "R", eu: 59.1, mm: 18.8 },
    "9": { uk: "R½", eu: 59.7, mm: 19.0 },
    "9 1/4": { uk: "S", eu: 60.3, mm: 19.2 },
    "9 1/2": { uk: "S½", eu: 60.9, mm: 19.4 },
    "9 3/4": { uk: "T", eu: 61.6, mm: 19.6 },
    "10": { uk: "T½", eu: 62.2, mm: 19.8 },
    "10 1/4": { uk: "U", eu: 62.8, mm: 20.0 },
    "10 1/2": { uk: "U½", eu: 63.5, mm: 20.2 },
    "10 3/4": { uk: "V", eu: 64.1, mm: 20.4 },
    "11": { uk: "V½", eu: 64.7, mm: 20.6 },
    "11 1/4": { uk: "W", eu: 65.3, mm: 20.8 },
    "11 1/2": { uk: "W½", eu: 66.0, mm: 21.0 },
    "11 3/4": { uk: "X", eu: 66.6, mm: 21.2 },
    "12": { uk: "X½", eu: 67.2, mm: 21.4 },
    "12 1/4": { uk: "Y", eu: 67.9, mm: 21.6 },
    "12 1/2": { uk: "Y½", eu: 68.5, mm: 21.8 },
    "12 3/4": { uk: "Z", eu: 69.1, mm: 22.0 },
    "13": { uk: "Z½", eu: 69.7, mm: 22.2 },
    "13 1/4": { uk: "Z+1", eu: 70.4, mm: 22.4 },
    "13 1/2": { uk: "Z+1½", eu: 71.0, mm: 22.6 },
    "13 3/4": { uk: "Z+2", eu: 71.6, mm: 22.8 },
    "14": { uk: "Z+2½", eu: 72.3, mm: 23.0 },
    "14 1/4": { uk: "Z+3", eu: 72.9, mm: 23.2 },
    "14 1/2": { uk: "Z+3½", eu: 73.5, mm: 23.4 },
    "14 3/4": { uk: "Z+4", eu: 74.1, mm: 23.6 },
    "15": { uk: "Z+4½", eu: 74.8, mm: 23.8 },
    "15 1/4": { uk: "Z+5", eu: 75.4, mm: 24.0 },
    "15 1/2": { uk: "Z+5½", eu: 76.0, mm: 24.2 },
    "15 3/4": { uk: "Z+6", eu: 76.7, mm: 24.4 },
    "16": { uk: "Z+6½", eu: 77.3, mm: 24.6 }
  };

  /* ─── Ring size drawer: search + US/UK-AU/EU/mm unit switcher ─── */
  function initRingSizeTools() {
    var drawer = document.querySelector('[data-ring-size-picker="true"]');
    if (!drawer) return;

    var searchInput = drawer.querySelector('[data-ring-size-search]');
    var emptyState  = drawer.querySelector('[data-ring-size-empty]');
    var emptyQuery  = drawer.querySelector('[data-ring-size-empty-query]');
    var unitSelect  = drawer.querySelector('[data-ring-unit-select]');
    var unitTrigger = drawer.querySelector('[data-ring-unit-trigger]');
    var unitLabel   = drawer.querySelector('[data-ring-unit-label]');
    var unitMenu    = drawer.querySelector('[data-ring-unit-menu]');
    var buttons     = Array.from(drawer.querySelectorAll('[data-size-picker-option]'));
    if (!buttons.length) return;

    var UNIT_NAMES = { us: 'US', uk: 'UK / AU', eu: 'EU', mm: '⌀ mm' };
    var currentUnit = 'us';

    // Attach conversion data + search terms, grouped by unit, to every
    // button once. Terms are matched with startsWith, never "contains" —
    // "contains" would let searching "3" match "10 3/4" (the fraction) or
    // "13", since both literally contain the character "3" somewhere.
    // Matching is also scoped to whichever unit is currently displayed —
    // searching "5" while viewing US sizes must only find US 5, 5¼, 5½, 5¾,
    // not size 6 (whose EU equivalent, 52, also happens to start with "5").
    buttons.forEach(function (btn) {
      var us = btn.dataset.value;
      var conv = RING_SIZE_CONVERSIONS[us];
      if (!conv) return;
      btn.dataset.uk = conv.uk;
      btn.dataset.eu = conv.eu;
      btn.dataset.mm = conv.mm;
      btn.searchTermsByUnit = {
        us: [us.toLowerCase()],
        uk: [conv.uk.toLowerCase(), conv.uk.toLowerCase().replace('½', ' 1/2')],
        eu: [String(conv.eu)],
        mm: [String(conv.mm), conv.mm + 'mm']
      };
    });

    function labelFor(btn, unit) {
      switch (unit) {
        case 'uk': return btn.dataset.uk;
        case 'eu': return btn.dataset.eu;
        case 'mm': return btn.dataset.mm + 'mm';
        default:   return btn.dataset.value;
      }
    }

    function applyUnit(unit) {
      currentUnit = unit;
      buttons.forEach(function (btn) {
        var labelEl = btn.querySelector('.spd-opt__label');
        if (labelEl && btn.dataset.uk) labelEl.textContent = labelFor(btn, unit);
      });
      if (unitLabel) unitLabel.textContent = UNIT_NAMES[unit];
      drawer.querySelectorAll('[data-ring-unit-menu] .spd-unit-select__option').forEach(function (opt) {
        var active = opt.dataset.unit === unit;
        opt.classList.toggle('is-active', active);
        opt.setAttribute('aria-selected', String(active));
      });
      // Switching unit changes what "matches" means for the current query
      // (e.g. "5" as a US size vs. "5" as an EU size), so re-filter.
      applySearch();
    }

    function closeUnitMenu() {
      if (unitSelect) unitSelect.removeAttribute('data-open');
      if (unitTrigger) unitTrigger.setAttribute('aria-expanded', 'false');
    }

    if (unitTrigger && unitSelect) {
      unitTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = unitSelect.getAttribute('data-open') === 'true';
        if (isOpen) {
          closeUnitMenu();
        } else {
          unitSelect.setAttribute('data-open', 'true');
          unitTrigger.setAttribute('aria-expanded', 'true');
        }
      });
      document.addEventListener('click', function (e) {
        if (!unitSelect.contains(e.target)) closeUnitMenu();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeUnitMenu();
      });
    }

    if (unitMenu) {
      unitMenu.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-unit]');
        if (!opt) return;
        applyUnit(opt.dataset.unit);
        closeUnitMenu();
      });
    }

    function applySearch() {
      var query = searchInput ? searchInput.value.trim().toLowerCase() : '';
      var visibleCount = 0;
      buttons.forEach(function (btn) {
        var terms = (btn.searchTermsByUnit && btn.searchTermsByUnit[currentUnit]) || [];
        var matches = !query || terms.some(function (term) {
          return term.indexOf(query) === 0;
        });
        btn.classList.toggle('spd-opt--search-hidden', !matches);
        if (matches) visibleCount += 1;
      });
      if (emptyState) {
        emptyState.hidden = visibleCount !== 0 || !query;
        if (emptyQuery) emptyQuery.textContent = searchInput ? searchInput.value.trim() : '';
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', applySearch);
    }
  }

  /* ─── Size picker drawer ─── */
  function initSizePicker() {
    var trigger = document.querySelector('[data-size-picker-trigger]');
    var drawer  = document.querySelector('[data-size-picker-drawer]');
    if (!trigger || !drawer) return;

    var sid      = drawer.dataset.sizePickerDrawer;
    var closeBtn = document.querySelector('[data-size-picker-close="' + sid + '"]');
    var overlay  = document.querySelector('[data-size-picker-overlay="' + sid + '"]');
    var display  = document.querySelector('[data-size-display]');
    var optsCont = document.querySelector('[data-size-picker-options]');
    if (!overlay) return;

    /* Teleport drawer + overlay to <body> to escape any parent stacking context
       (position:sticky on product column, opacity/transform on prd-enter, etc.) —
       position:fixed only covers the true viewport when it has no transformed/
       filtered ancestor, so both pieces must live directly under <body>.
       Visibility itself is driven purely by the body.size-picker-open class in
       CSS (see product-redesign.css), matching the collection filter panel. */
    document.body.appendChild(overlay);
    document.body.appendChild(drawer);

    function openPicker() {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('size-picker-open');
      if (window.__lenis) window.__lenis.stop();
      document.addEventListener('keydown', onEsc);
      updatePriceDeltas(drawer);
    }

    function closePicker() {
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('size-picker-open');
      if (window.__lenis) window.__lenis.start();
      document.removeEventListener('keydown', onEsc);
      trigger.focus({ preventScroll: true });
    }

    function onEsc(e) {
      if (e.key === 'Escape') closePicker();
    }

    trigger.addEventListener('click', openPicker);
    if (closeBtn) closeBtn.addEventListener('click', closePicker);
    overlay.addEventListener('click', closePicker);

    // Size Guide link from inside the picker — close picker then open size guide
    var guideBtn = document.querySelector('[data-size-picker-guide]');
    if (guideBtn) {
      guideBtn.addEventListener('click', function () {
        closePicker();
        setTimeout(function () {
          var sizeGuideBtn = document.querySelector('[data-size-panel-trigger]');
          if (sizeGuideBtn) sizeGuideBtn.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        }, 50);
      });
    }

    // Size option selection. Two modes, decided server-side (see
    // size-picker-drawer.liquid) by whether size_option_name matches a REAL
    // Shopify product option:
    //  - property mode (e.g. Ring Size): writes a cart line item property,
    //    same as Engraving Text. Doesn't touch price/inventory/variant.
    //  - real-option mode (e.g. Chain Length on necklaces): this option IS
    //    a genuine variant dimension with its own SKU/inventory, so the
    //    drawer has to actually drive it — same proxy technique
    //    initOptionBubbles() already uses for Metal/Color: find Dawn's own
    //    hidden native radio input by option name + value, check it, and
    //    dispatch "change" so the existing variant-price/availability/
    //    hidden-id machinery does the real work. Picking a value here NEVER
    //    just updates a label while silently leaving the wrong variant
    //    selected underneath.
    var propertyInput = document.querySelector('[data-size-property-input]');
    var isRealOption = drawer.dataset.sizeRealOption === 'true';
    var realOptionName = drawer.dataset.sizeRealOptionName;

    if (optsCont) {
      optsCont.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-size-picker-option]');
        if (!opt) return;

        var value = opt.dataset.value;

        // The visible label on this button reflects whatever unit is
        // currently active (US/UK-AU/EU/mm — see initRingSizeTools), so use
        // THAT for what the shopper sees and for the submitted property —
        // "show the ring size in the format it was selected". `value`
        // itself stays canonical (always the US label) for matching a real
        // Shopify variant option below, since that has to exactly match one
        // of the product's actual option values regardless of which unit
        // was on screen when it was clicked.
        var displayLabel = value;
        var labelEl = opt.querySelector('.spd-opt__label');
        if (labelEl) {
          var labelText = labelEl.textContent.replace(/\s+/g, ' ').trim();
          if (labelText) displayLabel = labelText;
        }

        // Update visual selection in picker
        optsCont.querySelectorAll('[data-size-picker-option]').forEach(function (o) {
          o.classList.toggle('is-selected', o === opt);
        });

        if (isRealOption && realOptionName) {
          var radios = document.querySelectorAll(
            '.product__info-container input[type="radio"][name="' + CSS.escape(realOptionName) + '"]'
          );
          radios.forEach(function (radio) {
            if (radio.value === value) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        } else if (propertyInput) {
          propertyInput.value = displayLabel;
          propertyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Update the size display in the main row
        if (display) {
          display.textContent = displayLabel;
          display.classList.remove('prd-row-value--muted');
        }

        // In 2-option dependent mode: ensure the selected chain row stays visible
        var selectedChainRow = document.querySelector('[data-selected-chain-row]');
        if (selectedChainRow) selectedChainRow.classList.remove('prd-chain-row--hidden');

        closePicker();
      });
    }
  }

  /* ─── Page enter animation ─── */
  function initEnterAnimation() {
    requestAnimationFrame(function () {
      setTimeout(function () {
        document.querySelectorAll('.prd-enter').forEach(function (el) {
          el.classList.add('is-visible');
        });
      }, 40);
    });
  }

  /* ─── Price delta badges in size-picker drawer ─── */
  function updatePriceDeltas(drawer) {
    var btns = Array.from(drawer.querySelectorAll('[data-size-picker-option][data-price]'));
    if (btns.length < 2) return;

    // Base = currently selected option's price; fallback to cheapest if nothing selected
    var selectedBtn = drawer.querySelector('[data-size-picker-option].is-selected');
    var basePrice = selectedBtn ? parseInt(selectedBtn.dataset.price, 10) : 0;
    if (!basePrice) {
      var allPrices = btns.map(function (b) { return parseInt(b.dataset.price, 10); }).filter(function (p) { return p > 0; });
      if (!allPrices.length) return;
      basePrice = Math.min.apply(null, allPrices);
    }

    btns.forEach(function (btn) {
      var badge = btn.querySelector('.spd-opt__price-badge');
      if (!badge) return;
      var price = parseInt(btn.dataset.price, 10);
      if (!price) return;
      var delta = price - basePrice;
      if (delta === 0) {
        badge.textContent = '';
      } else if (delta > 0) {
        badge.textContent = '+€' + (delta / 100).toFixed(0);
      } else {
        badge.textContent = '-€' + (Math.abs(delta) / 100).toFixed(0);
      }
    });
  }

  /* ─── Type bubbles for 2-option dependent chain pattern ─── */
  function initTypeBubbles() {
    var container = document.querySelector('[data-type-bubbles]');
    if (!container) return;

    var section = container.closest('[data-chain-trigger-value]');
    if (!section) return;

    var chainTriggerValue = section.dataset.chainTriggerValue;
    var typeOptionName    = section.dataset.typeOptionName;
    var chainOptionName   = section.dataset.chainOptionName;
    var selectedChainRow  = document.querySelector('[data-selected-chain-row]');
    var sizeTrigger       = document.querySelector('[data-size-picker-trigger]');
    var drawer            = document.querySelector('[data-size-picker-drawer]');

    container.addEventListener('click', function (e) {
      var bubble = e.target.closest('[data-type-bubble]');
      if (!bubble) return;

      var value           = bubble.dataset.value;
      var opensChainPicker = bubble.dataset.opensChainPicker === 'true';

      // Set native Option 1 radio → triggers variant update
      var radio = document.querySelector(
        '.product__info-container input[type="radio"][name="' + CSS.escape(typeOptionName) + '"][value="' + CSS.escape(value) + '"]'
      );
      if (radio) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Update bubble selected state
      container.querySelectorAll('[data-type-bubble]').forEach(function (b) {
        var active = b === bubble;
        b.classList.toggle('is-selected', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      if (opensChainPicker) {
        // "Chain" selected: don't silently pick a length for the customer —
        // no length radio is checked yet, so the variant stays incomplete
        // (native Dawn add-to-cart disabling handles that) until they
        // actually choose one in the drawer.
        // 1. Animate in the selected chain row, showing the muted placeholder
        if (selectedChainRow) selectedChainRow.classList.remove('prd-chain-row--hidden');

        // 2. Open the chain drawer after the row animation completes
        setTimeout(function () {
          if (sizeTrigger) sizeTrigger.dispatchEvent(new MouseEvent('click', { bubbles: true }));
        }, 360);

      } else {
        // Non-chain type (Coin Only, Cord Adjustable):
        // Close drawer if open, set N/A chain radio, hide chain row
        if (drawer) {
          drawer.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('size-picker-open');
          if (window.__lenis) window.__lenis.start();
        }

        var naRadio = document.querySelector(
          '.product__info-container input[type="radio"][name="' + CSS.escape(chainOptionName) + '"][value="N/A"]'
        );
        if (naRadio) {
          naRadio.checked = true;
          naRadio.dispatchEvent(new Event('change', { bubbles: true }));
        }

        if (selectedChainRow) selectedChainRow.classList.add('prd-chain-row--hidden');
      }
    });
  }

  /* ─── Option bubbles (Finish/Color etc.) ─── */
  function initOptionBubbles() {
    document.querySelectorAll('[data-option-bubbles]').forEach(function (container) {
      var optionName = container.dataset.optionName;

      container.addEventListener('click', function (e) {
        var bubble = e.target.closest('[data-option-bubble]');
        if (!bubble || bubble.classList.contains('is-unavailable')) return;

        var value = bubble.dataset.value;

        container.querySelectorAll('[data-option-bubble]').forEach(function (b) {
          var selected = b === bubble;
          b.classList.toggle('is-selected', selected);
          b.setAttribute('aria-pressed', String(selected));
        });

        // Sync to the hidden native variant radio (Dawn names inputs by option name)
        var radios = document.querySelectorAll(
          '.product__info-container input[type="radio"][name="' + CSS.escape(optionName) + '"]'
        );
        radios.forEach(function (radio) {
          if (radio.value === value) {
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });
  }

  /* ─── Autoplay product videos ─── */
  function initProductVideos() {
    document.querySelectorAll('.product-video-autoplay video').forEach(function (v) {
      v.setAttribute('playsinline', '');
      v.muted = true;
      v.loop = true;
      // Remove controls in case browser or Shopify JS added them
      v.removeAttribute('controls');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAccordions();
    initCtaConfirmation();
    initSizePicker();
    initRingSizeTools();
    initTypeBubbles();
    initOptionBubbles();
    initEnterAnimation();
    initProductVideos();
  });

})();
